import { User } from '@beatgig/api'
import { useMyAccount } from '@beatgig/auth-hooks'
import { useRef, useEffect } from 'react'
import useOpenAuthPopup from './use-open-auth-popup'

/**
 * Call this on the home page, for instance. Use it sparingly, if at all.
 */
export default function useAutomaticallyOpenOnboardingPopup() {
  const open = useOpenAuthPopup()
  const hasOpened = useRef(false)
  const { data } = useMyAccount()

  useEffect(() => {
    if (!hasOpened.current && data && !User.hasOnboarded(data)) {
      hasOpened.current = true
      open()
    }
  }, [data, open])
}
